<template>
  <transition leave-active-class="duration-200">
    <div
      v-show="opened"
      :class="
        'ios-scroll overflow-scroll h-full z-50 fixed bottom-0 px-4 inset-0 sm:p-0 ' +
        (!dynamicHeight ? 'flex justify-center items-center' : '')
      "
    >
      <!-- Background modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="opened"
          class="fixed inset-0 transition-opacity"
          @click="close"
        >
          <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
        </div>
      </transition>
      <!-- FIN Background modal -->

      <!-- Content modal -->
      <div
        v-if="dynamicHeight || crossedAbsoluteComponent"
        class="flex items-center justify-center"
      >
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            :class="
              'bg-white rounded-lg px-4 pt-5 pb-4 ' +
              minHeight +
              ' max-h-9/10 shadow-xl transform transition-all ' +
              width +
              ' sm:p-6' +
              (crossedAbsoluteComponent ? ' overflow-visible' : ' ' + overflow)
            "
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div
              v-if="!noCloseButton"
              class="cursor-pointer block absolute right-5 top-5 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
              @click="close"
            >
              <icon name="close" />
            </div>
            <slot />
          </div>
        </transition>
      </div>

      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          :class="
            'bg-white rounded-lg sm:m-5 px-4 pt-5 pb-4 ' +
            minHeight +
            ' max-h-9/10 shadow-xl transform transition-all ' +
            width +
            ' sm:p-6 ' +
            overflow
          "
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          v-if="!dynamicHeight && !crossedAbsoluteComponent"
        >
          <div
            v-if="!noCloseButton"
            class="cursor-pointer block absolute right-5 top-5 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
            @click="close"
          >
            <icon name="close" />
          </div>
          <slot />
        </div>
      </transition>
      <!-- END Content modal -->
    </div>
  </transition>
</template>

<script>
import Icon from './Icon';
export default {
  components: {
    Icon,
  },

  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    dynamicHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    crossedAbsoluteComponent: {
      type: Boolean,
      required: false,
      default: false,
    },
    noCloseButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    overflow: {
      type: String,
      required: false,
      default: 'overflow-scroll',
    },
    width: {
      type: String,
      required: false,
      default: 'lg:w-2/3 sm:w-full',
    },

    minHeight: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {};
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },

  watch: {},
};
</script>
<style scoped>
.ios-scroll {
  -webkit-overflow-scrolling: touch;
}
</style>
